/**
 * Created by vinay on 19/12/18.
 */
import initialStates from '../../initialStates';
import { FETCH_APPOINTMENTS_SUCCESS } from './appointmentsList-actions';

const appointmentsListReducer = (state = initialStates.appointmentList, action) => {
    let newState = {};
    switch (action.type) {
    case FETCH_APPOINTMENTS_SUCCESS:
        newState = Object.assign({}, state, {
            isLoading: false,
            list: action.data.content,
            page: action.data.number,
            size: action.data.size,
            totalElements: action.data.totalElements,
            filters: action.filters,
        });
        break;
    default:
        newState = state;
    }
    return newState;
};

export default appointmentsListReducer;
